// src/components/layout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './navbar';
import Footer from './footer';

/* 
  If you want to wrap your entire site in a background or 
  styling container, you can do so here.
*/
export default function Layout() {
  return (
    <>
      <Navbar />
      <Outlet />  {/* Each page content */}
      <Footer />
    </>
  );
}
